<template>
    <div class="homeBox">
        <div class="bk"></div>
        <div style="position: relative;top: -20px;">
            <div class="info">
                <div style="font-weight: bold;font-size: 18px;text-align: center;padding: 10px 0;">{{$DICT.getValue('SNAPSHOT_TYPE', detail.type)}}</div>
                <div style="color:#999999;font-size: 13px;text-align: center;padding: 0 0 15px 0;">{{detail.createUserRealName}}</div>
                <div style="color:#333333;">{{detail.describe}}</div>
                <div style="padding: 10px 0;color:#666666;font-size: 12px;">
                    <Icon name="location-o" style="top:1px"/>
                    {{detail.address}}
                </div>
                <div style="color:#666666;font-size: 12px;">
                    <Icon name="clock-o" style="top:1px"/>
                    {{detail.createdTime}}
            </div>
            </div>
            <div v-if="detail.state !== 'SUBMIT'" class="bottom">
                <div class="bottom-title">受理情况</div>
                <div style="display:flex;justify-content: space-between;font-size: 13px;padding: 10px;">
                    <div style="color:#333333;">案件状态</div>
                    <div :style="{color:(state== 'REJECT'?'#F91919':'#059B51')}">{{$DICT.getValue('SNAPSHOT_STATE', detail.state)}}</div>
                </div>
                <div style="display:flex;justify-content: space-between;font-size: 13px;padding: 10px;">
                    <div style="color:#333333;">受理时间</div>
                    <div style="color:#666666;">{{detail.handleTime}}</div>
                </div>
                <div style="display:flex;justify-content: space-between;font-size: 13px;padding: 10px;">
                    <div style="color:#333333;">受理人员</div>
                    <div style="color:#666666;">{{detail.handleUserRealName}}</div>
                </div>
                <div style="display:flex;justify-content: space-between;font-size: 13px;padding: 10px;">
                    <div style="color:#333333;white-space: nowrap;padding-right: 20px;">备注</div>
                    <div style="color:#666666;">{{detail.handleRemark}}</div>
                </div>
            </div>
        </div>
        
        
    </div>
</template>

<script>
import { Icon } from "vant"

export default {
     components: {
        Icon
    },
    data() {
        return{
            detail:{},
            state:''
        }
    },
    mounted() {
        this.detail = this.$route.params
        this.state = this.$route.params.state
    },
    methods:{}
}
</script>

<style scoped>
    .homeBox {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0px;
            background-image: linear-gradient(rgba(25, 137, 249, 1),rgba(25, 137, 249, 0) , #f3f3f3 70%);
        }
    .bk {
        background-color: RGBA(67, 133, 198, 1);
        height: 20px;
        margin: 30px 10px 10px 10px;
        border-radius: 10px;
    }
    .info {
        background-color: #fff;
        margin: 0  20px;
        padding: 10px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        
    }
    .bottom {
        background-color: #fff;
        margin: 10px  20px;
        border-radius: 10px;
        
    }
    .bottom-title {
        padding: 10px;
        font-weight: bold;
        border-bottom: 1px solid #eeeeee;
        

    }
</style>